import adminLogoSidebar from '~/assets/images/admin_logo_sidebar.svg';

const images = {
  adminLogoSidebar,
  adminBackgroundImageLogin: require('./admin_background_image_login.webp'),
};

export default images;
